export const initialState = {
  image: '',
  frontCardImage: '',
  backCardImage: ''
};
